const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question4-container");
const questionElement = document.getElementById("question4");
const answerButtonsElement = document.getElementById("answer-buttons4");
const ctaElement = document.getElementById("cta4");
const imgOne = document.getElementsByClassName("question4-one");
const imgTwo = document.getElementsByClassName("question4-two");
const imgThree = document.getElementsByClassName("question4-three");

const questions4 = [
  {
    question:
      "Do you have a…?",
    answers: [
      { text: "Sales team", correct: true },
      { text: "Customer Service team", correct: true },
    ],
  },
  {
    question: "How would you describe your team?",
    answers: [
      { text: "Exceptional", correct: true },
      { text: "Average", correct: true },
      { text: "Needs improvement", correct: true },
    ],
  },
  {
    question: "What do you need help with?",
    answers: [
      { text: "Appointment Organization", correct: true },
      { text: "Eliminating no-show meetings", correct: true },
      { text: "All of the above", correct: true },
    ],
  },
];


let shuffledQuestions4, currentQuestionIndex4;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex4++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions4 = questions4.sort();
  currentQuestionIndex4 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex4 > questions4.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions4[currentQuestionIndex4]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Good news! DYL’s Appointment Reminder feature lets your team quickly confirm upcoming appointments, so you know a customer is showing up. Click below to find out how.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}


function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}

function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/man-and-woman-excited-yellow-background.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-in-beautiful-nature-holding-hand-out.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",

  ];
function rotateGallery() {
  document.getElementById("ImgGalleryAR").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

